import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import i18n from 'i18n-js';
import { Button, createStyles, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';

import commonStyles from 'config/commonStyles';
import { ApplicationState } from 'store';
//import styles from '../styles';
import { images } from 'assets';
import { LocalStorageKeys } from 'constants/localStorageKeys';
import { useAppSelector } from 'index';
import TotalAmount from 'components/restaurantInformation/finance/components/TotalAmount';
import { AnimatedCounter } from 'components/shared';
import { helperFunctions } from 'helpers';

interface Props {
    tabs?: string[];
    toUpdate: boolean;
    onAddClick: () => void;
    onBackClick: () => void;
    activeTab: number;
    onTabChange: (i: number) => void;
    formChanged: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        headerContainer: {
            display: 'flex',
            alignItems: 'center',
            height: 55,
            padding: '0px 13px 0 28px',
            justifyContent: 'space-between',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
        },
        flexRowAlignCenter: {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
        },
        backArrow: { cursor: 'pointer', width: '24px', height: '24px', marginRight: '20px' },
        headerButtonContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
        tab: {
            padding: '0 0.5%',
            width: '100%',
            height: '100%',
            '& .MuiTab-wrapper': {
                letterSpacing: 1.25,
            },
            '& .MuiTabs-flexContainer': {
                height: '100%',
            },
            '& .MuiTab-root': {
                padding: 10,
            },
        },
        german: {
            '& .MuiTab-root': {
                padding: 7,
            },
        },
    })
);

export default function CreateRestaurantHeader({
    tabs = [
        i18n.t('restaurant.newRestaurant'),
        i18n.t('restaurant.restaurantUsers'),
        i18n.t('restaurant.finance'),
    ],
    toUpdate,
    onAddClick,
    onBackClick,
    onTabChange,
    activeTab,
    formChanged = false,
}: Props) {
    const sales = useSelector((state: ApplicationState) => state.finance.financeSales);
    const language = useAppSelector((state) => state.global.language);

    //const [view, setView] = useState(0);
    const classes = useStyles();

    useEffect(() => {
        checkLastTab();

        return () => {
            removeLastTab();
        };
    }, []); // eslint-disable-line

    function checkLastTab() {
        const lastTab = localStorage.getItem(LocalStorageKeys.restaurantInfoTab);
        if (lastTab) {
            const index = parseInt(lastTab);
            //setView(index);
            onTabChange(index);
        }
    }

    function saveLastTab(index: number) {
        localStorage.setItem(LocalStorageKeys.restaurantInfoTab, index.toString());
    }

    function removeLastTab() {
        localStorage.removeItem(LocalStorageKeys.restaurantInfoTab);
    }

    function financeTotalAmountContainer() {
        return (
            <TotalAmount
                currency={'CHF'}
                title={i18n.t('common.total')}
                amount={
                    <AnimatedCounter
                        value={sales.totalAmount}
                        formatFn={(val) => helperFunctions.formatNumber(val)}
                    />
                }
            />
        );
    }

    function changeTab(_: React.ChangeEvent<{}>, view: number) {
        onTabChange(view); //setView(view);
    }

    return (
        <div className={classes.headerContainer}>
            <div className={classes.flexRowAlignCenter}>
                <img
                    src={images.icons.backArrow}
                    className={classes.backArrow}
                    onClick={onBackClick}
                    alt="back-arrow"
                />
                <Tabs
                    value={activeTab}
                    onChange={changeTab}
                    aria-label="wrapped label tabs example"
                    indicatorColor="primary"
                    textColor="primary"
                    className={`${classes.tab} ${language === 'de' ? classes.german : ''}`}
                >
                    {tabs.map((tab, i) => (
                        <Tab
                            key={tab}
                            style={{ textTransform: tabs.length === 1 ? 'none' : '-moz-initial' }}
                            value={i}
                            label={tab}
                            onClick={() => {
                                onTabChange(i);
                                saveLastTab(i);
                            }}
                        />
                    ))}
                </Tabs>
            </div>

            {activeTab === 3 && financeTotalAmountContainer()}
            <div style={{ visibility: activeTab === 0 ? 'visible' : 'hidden' }}>
                <div className={classes.headerButtonContainer}>
                    <Button
                        /* style={styles.button} */
                        onClick={() => onAddClick()}
                        variant="contained"
                        color="primary"
                        disabled={!formChanged}
                    >
                        {i18n.t('common.save')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
